import { verifyEmailSignupRouteSearchSchema } from "@/features/auth/search/authRouteSearch";
import { VerifyEmailScreen } from "@/features/auth/screens/VerifyEmailScreen";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { supabaseClient } from "@/lib/supabase";

const VerifyEmail = () => {
    const { email, first_name } = Route.useSearch();
    return <VerifyEmailScreen email={email} firstName={first_name} />;
};

export const Route = createFileRoute("/_auth/verify-email")({
    component: VerifyEmail,
    validateSearch: (search) => verifyEmailSignupRouteSearchSchema.parse(search ?? {}),
    beforeLoad: async ({ search }) => {
        const email = search.email as string;

        if (!email) {
            throw new Error("Email is required");
        }

        // Set the email on the anonymous user immediately
        // This is critical - the anonymous user needs an email before setting password
        const { data: updateData, error } = await supabaseClient.auth.updateUser({
            email: email,
        });

        if (error) {
            console.error("Failed to set email on user:", error);
            throw new Error("Failed to set email. Please try again.");
        }

        console.log("✅ Email set on user:", email);

        // Check if email was auto-confirmed (verification disabled in dev)
        if (updateData?.user?.email_confirmed_at) {
            console.log("✅ Email auto-confirmed, skipping verification");
            // Auto-confirmed - redirect to set password
            throw redirect({ to: "/set-password" });
        }

        // Email verification required - show verification UI
        console.log("⚠️ Email verification required");
    },
});
